export default __webpack_public_path__ + "static/media/spatula.331457c7.png";